// Development mode configuration
// Set this to true to bypass Auth0 authentication for development

// Mock user data for development mode
export const MOCK_USER = {
  name: 'Dev User',
  picture: '/placeholder-user.jpg',
  email: 'dev@example.com'
};

// Helper function to check if we should use dev mode
export function isDevMode(): boolean {
  return process.env.NODE_ENV === 'development' && process.env.DEV_MODE === 'true';
}

/**
 * Helper function to determine if debug tools should be shown
 * Shows debug tools when ALL conditions are met:
 * - Feature flag enabled (NEXT_PUBLIC_ENABLE_DEBUG_PANEL === 'true')
 * - AND one of:
 *   - Local development (NODE_ENV === 'development')
 *   - Azure dev environment (NEXT_PUBLIC_ENVIRONMENT === 'dev' or 'staging' OR hostname contains '.dev.')
 * 
 * Hides in:
 * - Azure production (NEXT_PUBLIC_ENVIRONMENT === 'production' AND hostname doesn't contain '.dev.')
 * - Feature flag disabled (NEXT_PUBLIC_ENABLE_DEBUG_PANEL !== 'true')
 */
export function shouldShowDebugTools(): boolean {
  // Check feature flag first (secure by default)
  const debugPanelEnabled = process.env.NEXT_PUBLIC_ENABLE_DEBUG_PANEL?.toLowerCase() === 'true';
  if (!debugPanelEnabled) {
    return false;
  }
  
  // Always show in local development if feature flag is enabled
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  
  // Check NEXT_PUBLIC_ENVIRONMENT for Azure environments (build-time)
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT?.toLowerCase();
  if (environment === 'dev' || environment === 'staging') {
    return true;
  }
  
  // Fallback: Check hostname at runtime (for cases where NEXT_PUBLIC_ENVIRONMENT isn't set at build time)
  // This works because hostname is available at runtime in the browser
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    // Check if hostname contains '.dev.' (e.g., dt-debtcast.dev.devtechlab.com)
    if (hostname.includes('.dev.')) {
      return true;
    }
  }
  
  return false;
}
